/**
 * @param storeState
 * @returns {*} file
 */
export const getPendingFileForUpload = (storeState) => storeState.upload.file;
